import { LangText } from '@/components'
import circleImage from '@/assets/svg/circle.svg'
import { preFixImgUrl } from '@/utils'

const FEATURE_ITEMS = [
  {
    image: '987af9456011566bc82abbe0b8caf40d.png',
    titleKey: 'hanedaShop.features.items.advanceBooking.title',
    descriptionKey: 'hanedaShop.features.items.advanceBooking.description',
  },
  {
    image: '56c19bbe322aa4018f65c79bb4c3e67f.png',
    titleKey: 'hanedaShop.features.items.onlineOrder.title',
    descriptionKey: 'hanedaShop.features.items.onlineOrder.description',
  },
  {
    image: '71de20b32ff95b77176f8ba4ea70cb75.png',
    titleKey: 'hanedaShop.features.items.counterPickup.title',
    descriptionKey: 'hanedaShop.features.items.counterPickup.description',
  },
  {
    image: '5abb5d0d9dddab13c43bb0872eb1aea3.png',
    titleKey: 'hanedaShop.features.items.customerService.title',
    descriptionKey: 'hanedaShop.features.items.customerService.description',
  },
] as const

const ServiceFeatures = () => (
  <section className="w-full bg-white py-[60px]">
    <div className="mx-auto w-[1200px]">
      <div className="flex flex-col items-center">
        <LangText
          lngKey="hanedaShop.features.title"
          className="text-[36px] font-bold leading-[50px] text-[#000000]"
        />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-primary" />
      </div>

      <div className="mt-[48px] grid grid-cols-2 gap-[32px]">
        {FEATURE_ITEMS.map((item) => (
          <article
            key={item.titleKey}
            className="group relative flex items-center overflow-hidden rounded-[20px] border border-[#E3DCDD] px-[32px] transition-[border-color,box-shadow,transform] duration-300 ease-out"
            style={{
              height: 224,
              background: 'linear-gradient(180deg, #FFF7F2 0%, #EDF5FF 100%)',
            }}
          >
            <img
              src={preFixImgUrl(item.image)}
              alt=""
              className="relative z-[2] h-[160px] w-[160px] shrink-0 object-contain transition-transform duration-300 ease-out group-hover:scale-110"
              draggable={false}
            />

            <div className="relative z-[2] ml-[24px] min-w-0 flex-1 text-center">
              <LangText
                lngKey={item.titleKey}
                className="inline-block font-smiley-sans text-[32px] font-medium leading-[38px] text-primary transition-[color,transform] duration-300 ease-out group-hover:translate-x-[3px] group-hover:text-[#126FD9]"
              />
              <LangText
                lngKey={item.descriptionKey}
                className="mt-[16px] block whitespace-pre-line text-[20px] leading-[28px] text-[#979797] transition-colors duration-300 group-hover:text-[#777777]"
              />
            </div>

            <img
              src={circleImage}
              alt=""
              className="pointer-events-none absolute bottom-[-164px] right-[-112px] z-[1] h-[306px] w-[306px] transition-transform duration-500 ease-out group-hover:scale-125"
              aria-hidden
            />
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default ServiceFeatures
